import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { categoryService } from '../services/categoryService';
import CategoryForm from './CategoryForm';

// CategoryCard component for rendering individual categories
function CategoryCard({
  category,
  viewMode,
  expandedCategories,
  onToggleExpanded,
  onEdit,
  onDelete,
  onAddSubcategory,
  isSubcategory = false
}) {
  return (
    <div>
      <div
        style={{
          background: isSubcategory
            ? 'rgba(255, 107, 53, 0.03)'
            : 'rgba(255, 107, 53, 0.05)',
          border: isSubcategory
            ? '1px solid #303030'
            : '1px solid #404040',
          borderRadius: '12px',
          padding: isSubcategory ? '16px' : '20px',
          transition: 'all 0.2s ease',
          marginLeft: isSubcategory ? '24px' : '0',
          position: 'relative'
        }}
        onMouseEnter={(e) => e.currentTarget.style.borderColor = category.color}
        onMouseLeave={(e) => e.currentTarget.style.borderColor = isSubcategory ? '#303030' : '#404040'}
      >
        {isSubcategory && (
          <div style={{
            position: 'absolute',
            left: '-12px',
            top: '50%',
            transform: 'translateY(-50%)',
            width: '2px',
            height: '60%',
            backgroundColor: category.color,
            borderRadius: '1px'
          }} />
        )}

        <div style={{
          display: 'flex',
          alignItems: 'center',
          marginBottom: '12px',
          justifyContent: 'space-between'
        }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <span style={{
              fontSize: isSubcategory ? '20px' : '24px',
              marginRight: '12px'
            }}>
              {category.icon}
            </span>
            <h3 style={{
              margin: '0',
              color: '#f0f0f0',
              fontSize: isSubcategory ? '1rem' : '1.1rem',
              fontWeight: '600'
            }}>
              {category.name}
            </h3>
            {isSubcategory && (
              <span style={{
                marginLeft: '8px',
                fontSize: '12px',
                color: '#888',
                fontStyle: 'italic'
              }}>
                subcategory
              </span>
            )}
          </div>

          {viewMode === 'hierarchical' && !isSubcategory && category.subcategories && category.subcategories.length > 0 && (
            <button
              onClick={() => onToggleExpanded(category.id)}
              style={{
                background: 'none',
                border: 'none',
                color: category.color,
                cursor: 'pointer',
                fontSize: '18px',
                padding: '4px',
                borderRadius: '4px',
                transition: 'all 0.2s ease'
              }}
              onMouseEnter={(e) => e.target.style.background = 'rgba(255, 107, 53, 0.1)'}
              onMouseLeave={(e) => e.target.style.background = 'none'}
            >
              {expandedCategories.has(category.id) ? '▼' : '▶'}
            </button>
          )}
        </div>

        <div style={{
          display: 'flex',
          alignItems: 'center',
          marginBottom: '12px'
        }}>
          <div style={{
            width: '20px',
            height: '20px',
            backgroundColor: category.color,
            borderRadius: '4px',
            marginRight: '8px'
          }}></div>
          <span style={{
            color: '#b0b0b0',
            fontSize: '14px'
          }}>
            {category.color}
          </span>
          {viewMode === 'hierarchical' && !isSubcategory && category.subcategories && category.subcategories.length > 0 && (
            <span style={{
              marginLeft: '12px',
              fontSize: '12px',
              color: '#888',
              background: 'rgba(255, 107, 53, 0.1)',
              padding: '2px 6px',
              borderRadius: '8px'
            }}>
              {category.subcategories.length} subcategory{category.subcategories.length !== 1 ? 'ies' : 'y'}
            </span>
          )}
        </div>

        {category.budgetLimit && (
          <div style={{
            marginBottom: '16px',
            padding: '8px 12px',
            background: 'rgba(52, 152, 219, 0.1)',
            border: '1px solid rgba(52, 152, 219, 0.2)',
            borderRadius: '6px'
          }}>
            <div style={{
              fontSize: '12px',
              color: '#3498db',
              fontWeight: '600',
              marginBottom: '2px'
            }}>
              Monthly Budget
            </div>
            <div style={{
              fontSize: '14px',
              color: '#f0f0f0',
              fontWeight: '600'
            }}>
              ${category.budgetLimit.toLocaleString()}
            </div>
          </div>
        )}

        {category.keywords && category.keywords.length > 0 && (
          <div style={{
            marginBottom: '16px',
            padding: '8px 12px',
            background: 'rgba(155, 89, 182, 0.1)',
            border: '1px solid rgba(155, 89, 182, 0.2)',
            borderRadius: '6px'
          }}>
            <div style={{
              fontSize: '12px',
              color: '#fff',
              fontWeight: '600',
              marginBottom: '6px'
            }}>
              Auto-Match Keywords
            </div>
            <div style={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: '4px'
            }}>
              {category.keywords.slice(0, 5).map((keyword, index) => (
                <span
                  key={index}
                  style={{
                    background: 'rgba(155, 89, 182, 0.2)',
                    color: '#fff',
                    padding: '2px 6px',
                    borderRadius: '8px',
                    fontSize: '10px',
                    fontWeight: '500'
                  }}
                >
                  {keyword}
                </span>
              ))}
              {category.keywords.length > 5 && (
                <span style={{
                  color: '#888',
                  fontSize: '10px',
                  padding: '2px 4px'
                }}>
                  +{category.keywords.length - 5} more
                </span>
              )}
            </div>
          </div>
        )}

        <div style={{
          display: 'flex',
          gap: '8px',
          justifyContent: 'flex-end',
          flexWrap: 'wrap'
        }}>
          {viewMode === 'hierarchical' && !isSubcategory && (
            <button
              onClick={() => onAddSubcategory(category)}
              style={{
                background: 'rgba(46, 204, 113, 0.2)',
                border: '1px solid #2ecc71',
                color: '#2ecc71',
                padding: '6px 12px',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '12px',
                fontWeight: '500'
              }}
            >
              + Sub
            </button>
          )}
          <button
            onClick={() => onEdit(category)}
            style={{
              background: 'rgba(255, 107, 53, 0.2)',
              border: '1px solid #ff6b35',
              color: '#ff6b35',
              padding: '6px 12px',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '12px',
              fontWeight: '500'
            }}
          >
            Edit
          </button>
          {!category.isDefault && (
            <button
              onClick={() => onDelete(category.id)}
              style={{
                background: 'rgba(255, 71, 87, 0.2)',
                border: '1px solid #ff4757',
                color: '#ff4757',
                padding: '6px 12px',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '12px',
                fontWeight: '500'
              }}
            >
              Delete
            </button>
          )}
        </div>

        {category.isDefault && (
          <div style={{
            marginTop: '8px',
            fontSize: '11px',
            color: '#888',
            textAlign: 'center'
          }}>
            Default Category
          </div>
        )}
      </div>

      {viewMode === 'hierarchical' &&
        category.subcategories &&
        category.subcategories.length > 0 &&
        expandedCategories.has(category.id) && (
          <div style={{ marginTop: '12px', display: 'grid', gap: '12px' }}>
            {category.subcategories.map((subcategory) => (
              <CategoryCard
                key={subcategory.id}
                category={subcategory}
                viewMode={viewMode}
                expandedCategories={expandedCategories}
                onToggleExpanded={onToggleExpanded}
                onEdit={onEdit}
                onDelete={onDelete}
                onAddSubcategory={onAddSubcategory}
                isSubcategory={true}
              />
            ))}
          </div>
        )}
    </div>
  );
}

function Categories() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editingCategory, setEditingCategory] = useState(null);
  const [parentCategory, setParentCategory] = useState(null);
  const [error, setError] = useState('');
  const [isInitializing, setIsInitializing] = useState(false);
  const [viewMode, setViewMode] = useState('hierarchical'); // 'hierarchical' or 'flat'
  const [expandedCategories, setExpandedCategories] = useState(new Set());
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    loadCategories();
  }, [viewMode]);

  const loadCategories = async () => {
    try {
      setLoading(true);
      const data = viewMode === 'hierarchical'
        ? await categoryService.getCategories()
        : await categoryService.getCategoriesFlat();
      let categoriesList = data.categories || [];

      // If no categories exist, initialize defaults (but only if not already initializing)
      if (categoriesList.length === 0 && !isInitializing) {
        await initializeDefaults();
        return;
      }

      if (viewMode === 'flat') {
        // Sort flat categories alphabetically by name
        categoriesList.sort((a, b) => a.name.localeCompare(b.name));
      } else {
        // Sort hierarchical categories alphabetically by name
        categoriesList.sort((a, b) => a.name.localeCompare(b.name));
        // Also sort subcategories within each parent
        categoriesList.forEach(category => {
          if (category.subcategories && category.subcategories.length > 0) {
            category.subcategories.sort((a, b) => a.name.localeCompare(b.name));
          }
        });
      }

      setCategories(categoriesList);
    } catch (error) {
      console.error('Failed to load categories:', error);
      setError('Failed to load categories');
    } finally {
      setLoading(false);
    }
  };

  const initializeDefaults = async () => {
    try {
      setIsInitializing(true);
      const data = await categoryService.initializeDefaultCategories();
      let categoriesList = data.categories || [];

      // Sort categories alphabetically by name
      categoriesList.sort((a, b) => a.name.localeCompare(b.name));
      setCategories(categoriesList);
    } catch (error) {
      console.error('Failed to initialize default categories:', error);
    } finally {
      setIsInitializing(false);
    }
  };

  const handleAddCategory = async (categoryData) => {
    try {
      await categoryService.createCategory(categoryData);
      setShowForm(false);
      setParentCategory(null);
      loadCategories();
    } catch (error) {
      console.error('Failed to add category:', error);
      setError(error.response?.data?.error || 'Failed to add category');
    }
  };

  const handleEditCategory = async (categoryData) => {
    try {
      await categoryService.updateCategory(editingCategory.id, categoryData);
      setEditingCategory(null);
      setShowForm(false);
      loadCategories();
    } catch (error) {
      console.error('Failed to update category:', error);
      setError(error.response?.data?.error || 'Failed to update category');
    }
  };

  const handleDeleteCategory = async (categoryId) => {
    if (!window.confirm('Are you sure you want to delete this category?')) {
      return;
    }

    try {
      await categoryService.deleteCategory(categoryId);
      loadCategories();
    } catch (error) {
      console.error('Failed to delete category:', error);
      setError(error.response?.data?.error || 'Failed to delete category');
    }
  };

  const startEdit = (category) => {
    setEditingCategory(category);
    setParentCategory(null);
    setShowForm(true);
  };

  const startAddSubcategory = (parent) => {
    setParentCategory(parent);
    setEditingCategory(null);
    setShowForm(true);
  };

  const cancelForm = () => {
    setShowForm(false);
    setEditingCategory(null);
    setParentCategory(null);
    setError('');
  };

  const toggleExpanded = (categoryId) => {
    const newExpanded = new Set(expandedCategories);
    if (newExpanded.has(categoryId)) {
      newExpanded.delete(categoryId);
    } else {
      newExpanded.add(categoryId);
    }
    setExpandedCategories(newExpanded);
  };

  if (loading) {
    return (
      <div className="accounts-container">
        <header className="page-header">
          <div className="page-header-content">
            <h1 className="page-title">Categories</h1>
            <p className="page-subtitle">
              Manage your expense categories for <span style={{ color: '#ff6b35', fontWeight: '600' }}>{user?.familyName}</span>
            </p>

            <nav className="page-nav">
              <button onClick={() => navigate('/home')} className="nav-btn">
                📊 Dashboard
              </button>
              <button onClick={() => navigate('/categories')} className="nav-btn active">
                📂 Categories
              </button>
              <button onClick={() => navigate('/accounts')} className="nav-btn">
                🏦 Accounts
              </button>
              <button onClick={() => navigate('/help')} className="nav-btn">
                ❓ Help
              </button>
            </nav>
          </div>
          <button onClick={logout} className="btn logout-btn">
            Logout
          </button>
        </header>

        <div className="card">
          <div style={{
            textAlign: 'center',
            padding: '40px',
            color: '#b0b0b0',
            fontSize: '1.1rem'
          }}>
            Loading categories...
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="accounts-container">
      <header className="page-header">
        <div className="page-header-content">
          <h1 className="page-title">Categories</h1>
          <p className="page-subtitle">
            Manage your expense categories for <span style={{ color: '#ff6b35', fontWeight: '600' }}>{user?.familyName}</span>
          </p>

          <nav className="page-nav">
            <button onClick={() => navigate('/home')} className="nav-btn">
              📊 Dashboard
            </button>
            <button onClick={() => navigate('/categories')} className="nav-btn active">
              📂 Categories
            </button>
            <button onClick={() => navigate('/accounts')} className="nav-btn">
              🏦 Accounts
            </button>
            <button onClick={() => navigate('/help')} className="nav-btn">
              ❓ Help
            </button>
          </nav>
        </div>
        <button
          onClick={logout}
          className="btn logout-btn"
        >
          Logout
        </button>
      </header>

      <div className="card">
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '24px',
          flexWrap: 'wrap',
          gap: '16px'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
            <h2 style={{
              color: '#f0f0f0',
              margin: '0',
              fontSize: '1.8rem',
              fontWeight: '600'
            }}>
              Expense Categories
            </h2>

            <div style={{
              display: 'flex',
              background: 'rgba(255, 107, 53, 0.1)',
              borderRadius: '8px',
              padding: '4px',
              border: '1px solid rgba(255, 107, 53, 0.2)'
            }}>
              <button
                onClick={() => setViewMode('hierarchical')}
                style={{
                  background: viewMode === 'hierarchical' ? '#ff6b35' : 'transparent',
                  color: viewMode === 'hierarchical' ? '#fff' : '#ff6b35',
                  border: 'none',
                  padding: '6px 12px',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  fontSize: '12px',
                  fontWeight: '500',
                  transition: 'all 0.2s ease'
                }}
              >
                🌳 Tree View
              </button>
              <button
                onClick={() => setViewMode('flat')}
                style={{
                  background: viewMode === 'flat' ? '#ff6b35' : 'transparent',
                  color: viewMode === 'flat' ? '#fff' : '#ff6b35',
                  border: 'none',
                  padding: '6px 12px',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  fontSize: '12px',
                  fontWeight: '500',
                  transition: 'all 0.2s ease'
                }}
              >
                📋 List View
              </button>
            </div>
          </div>

          <button
            onClick={() => setShowForm(true)}
            className="btn"
          >
            + Add Category
          </button>
        </div>

        {(() => {
          const calculateTotalBudget = (cats) => {
            let total = 0;
            cats.forEach(cat => {
              if (cat.budgetLimit) {
                total += cat.budgetLimit;
              }
              if (cat.subcategories && cat.subcategories.length > 0) {
                cat.subcategories.forEach(sub => {
                  if (sub.budgetLimit) {
                    total += sub.budgetLimit;
                  }
                });
              }
            });
            return total;
          };

          const totalBudget = calculateTotalBudget(categories);

          return totalBudget > 0 ? (
            <div style={{
              background: 'linear-gradient(135deg, rgba(52, 152, 219, 0.15) 0%, rgba(46, 204, 113, 0.15) 100%)',
              border: '2px solid rgba(52, 152, 219, 0.3)',
              borderRadius: '12px',
              padding: '20px',
              marginBottom: '24px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              flexWrap: 'wrap',
              gap: '12px'
            }}>
              <div>
                <div style={{
                  fontSize: '14px',
                  color: '#3498db',
                  fontWeight: '600',
                  marginBottom: '4px',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px'
                }}>
                  Total Monthly Budget
                </div>
                <div style={{
                  fontSize: '32px',
                  color: '#f0f0f0',
                  fontWeight: '700'
                }}>
                  ${totalBudget.toLocaleString()}
                </div>
              </div>
              <div style={{
                fontSize: '48px',
                opacity: 0.3
              }}>
                💰
              </div>
            </div>
          ) : null;
        })()}

        {error && (
          <div style={{
            color: '#ff4757',
            backgroundColor: 'rgba(255, 71, 87, 0.1)',
            padding: '12px',
            borderRadius: '8px',
            marginBottom: '20px',
            border: '1px solid rgba(255, 71, 87, 0.3)'
          }}>
            {error}
          </div>
        )}

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
          gap: '16px'
        }}>
          {categories.map((category) => (
            <CategoryCard
              key={category.id}
              category={category}
              viewMode={viewMode}
              expandedCategories={expandedCategories}
              onToggleExpanded={toggleExpanded}
              onEdit={startEdit}
              onDelete={handleDeleteCategory}
              onAddSubcategory={startAddSubcategory}
            />
          ))}
        </div>

        {categories.length === 0 && (
          <div style={{
            textAlign: 'center',
            padding: '60px 40px',
            color: '#888',
            background: 'rgba(255, 107, 53, 0.05)',
            borderRadius: '12px',
            border: '2px dashed #404040'
          }}>
            <div style={{ fontSize: '3rem', marginBottom: '16px' }}>📂</div>
            <p style={{ fontSize: '1.2rem', margin: '0' }}>
              No categories found. Click "Add Category" to create your first one!
            </p>
          </div>
        )}
      </div>

      {showForm && (
        <CategoryForm
          category={editingCategory}
          parentCategory={parentCategory}
          onSave={editingCategory ? handleEditCategory : handleAddCategory}
          onCancel={cancelForm}
        />
      )}
    </div>
  );
}

export default Categories;